import React, { useState, useEffect } from 'react'
/** @jsx jsx */
import { jsx } from '@emotion/core'
import {
  Modal,
  DatePicker,
  Select,
  Button,
  Radio,
  message,
  Spin,
  Checkbox,
} from 'antd'
import { windExportPerformanceData } from 'api/pgads'
import moment from 'moment'
import { downloadFile, isValidYearRange } from 'core/utils'
import { JcTmpErrorTable } from 'core/component/JcTmpErrorDialog'
export default ({
  apiTargetInfo,
  visible,
  setVisible,
  utilityList,
  utilitySelectionList,
  setSpinning,
  setError,
  spinning,
  validYearRange = 10,
}) => {
  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([
    moment(),
    moment(),
  ])
  const [selUtility, setSelUtility] = useState('ALL')
  const [selSubGroups, setSelSubgroups] = useState([])
  const [fileType, setFileType] = useState('CSV')
  const [errorList, setErrorList] = useState([])
  const [fileNames, setFileNames] = useState([])
  const [selectAllCheckbox, setSelectAllCheckbox] = useState(false)
  useEffect(
    _ => {
      setSelSubgroups([])
    },
    [selUtility]
  )
  useEffect(
    _ => {
      setErrorList([])
      setFileNames([])
      // setSelectAllCheckbox(false)
    },
    [selUtility, fileType, selSubGroups, selectedDateRangePicker]
  )

  useEffect(
    _ => {
      setSelectAllCheckbox(false)
    },
    [selUtility, selectedDateRangePicker]
  )

  const closeDialog = _ => {
    setErrorList([])
    setFileNames([])
    setVisible()
  }

  const exportNercFile = _ => {
    if (selSubGroups.length <= 0) {
      message.info('Please , Select Subgroup')
      return
    }
    const isValid = isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return

    setSpinning(true)
    windExportPerformanceData(apiTargetInfo)({
      fileType,
      data: selSubGroups.map(s => ({
        utility: s.substr(0, s.indexOf('-')),
        subgroupId: s.substr(s.indexOf('-') + 1),
      })),
      startDate: selectedDateRangePicker[0].startOf('month'),
      endDate: selectedDateRangePicker[1].endOf('month'),
    }).fork(setError, resObj => {
      setSpinning(false)
      const { errorList, fileNames, havingDataforExport } = resObj

      if (!havingDataforExport) {
        message.warning('No valid data found for creating the submission file.')
      } else {
        setErrorList(errorList)
        setFileNames(fileNames)

        if (fileNames.length === 0) {
          message.warning('No data for Export')
          return ''
        }
        if (errorList.length === 0 && fileNames.length > 0) {
          callContinue(fileNames)
        }
      }
    })
  }
  const callContinue = fileNames => {
    fileNames.forEach(fileName => {
      downloadFile(apiTargetInfo)(
        `windpowerdata/download-file?filename=${encodeURIComponent(fileName)}`
      )(fileName)
    })
    closeDialog()
  }

  const selectAllSubgroup = checked => {
    setSelectAllCheckbox(checked)
    if (checked) {
      const all = utilitySelectionList
        .filter(f => (selUtility === 'ALL' ? true : f.utility === selUtility))
        .map(m => m.utility + '-' + m.subgroupId)
      setSelSubgroups(all)
    } else setSelSubgroups([])
  }

  return (
    <Modal
      visible={visible}
      destroyOnClose
      closable
      onOk={closeDialog}
      onCancel={closeDialog}
      width={800}
      style={{ zIndex: 1000, top: '10px' }}
      title="Create Performance File"
      footer={_ => <div />}
      spinning={spinning}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '100px 650px',
            gridTemplateRows: '50px 50px  100px 50px auto',
          }}
        >
          <div>Select Month</div>
          <DatePicker.RangePicker
            allowClear={false}
            mode={['month', 'month']}
            // mode="decade"
            format="MMMM-YYYY"
            value={selectedDateRangePicker}
            placeholder={['Start month', 'End month']}
            // open={openPicker}
            onChange={dates => {
              setSelectedDateRagePicker(dates)
            }}
            onPanelChange={dates => {
              setSelectedDateRagePicker(dates)
            }}
          />
          <div>Utility</div>
          <Select
            onChange={setSelUtility}
            css={{ minWidth: '200px' }}
            value={selUtility}
          >
            {utilityList.map(m => (
              <Select.Option key={m.key} value={m.key}>
                {m.key + '-' + m.value}
              </Select.Option>
            ))}
          </Select>
          <div>Subgroup</div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              gridTemplateRows: '1fr',
              overflow: 'auto',
              margin: '2px',
              padding: '1px',
            }}
          >
            <Select
              mode="multiple"
              onChange={setSelSubgroups}
              value={selSubGroups}
              css={{ display: 'grid' }}
              placeholder="Click to Select Subgroups"
            >
              {utilitySelectionList
                .filter(f =>
                  selUtility === 'ALL' ? true : f.utility === selUtility
                )
                .map(m => (
                  <Select.Option
                    key={m.utility + '-' + m.subgroupId}
                    value={m.utility + '-' + m.subgroupId}
                  >
                    {m.subgroupId + '-' + m.subgroupName}
                  </Select.Option>
                ))}
            </Select>
          </div>
          <div />
          <div
            css={{
              display: 'flex',
              justifyContent: 'space-evenly',
              marginTop: '10px',
            }}
          >
            <Checkbox
              checked={selectAllCheckbox}
              // value={selectAllCheckbox}
              onChange={e => selectAllSubgroup(e.target.checked)}
            >
              Select All
            </Checkbox>
            <Radio.Group
              value={fileType}
              onChange={e => setFileType(e.target.value)}
            >
              <Radio value="CSV">CSV</Radio>
              <Radio value="EXCEL">EXCEL</Radio>
            </Radio.Group>
            <Button type="primary" onClick={exportNercFile}>
              Create File
            </Button>
            {errorList.length > 0 && (
              <Button type="danger" onClick={_ => callContinue(fileNames)}>
                Download File
              </Button>
            )}
            <Button type="danger" onClick={closeDialog}>
              Cancel
            </Button>
          </div>
          {errorList.length > 0 && (
            // <div
            //   style={{
            //     display: 'grid',
            //     gridTemplateColumns: '1fr',
            //     gridTemplateRows: '1fr',
            //     gridColumn: 'span 2',
            //     maxHeight: '300px',
            //     overflow: 'non',
            //   }}
            // >
            <JcTmpErrorTable
              errors={errorList}
              style={{ gridColumn: 'span 2' }}
              scroll={{ y: 200 }}
            />
            // </div>
          )}
        </div>
      </Spin>
    </Modal>
  )
}
